import { qportalApi } from './qportal-api';
const getAll = async () => {
    return qportalApi.get('internalcompany');
};
const createOrUpdate = async (payload) => {
    return qportalApi.put('internalcompany', payload);
};
const InternalCompanyApi = {
    details: (id) => qportalApi.get(`internalcompany/${encodeURIComponent(id)}/faqtoring-details`),
    retry: (id) => qportalApi.post(`internalcompany/${encodeURIComponent(id)}/faqtoring-retry`),
    getAll,
    createOrUpdate
};
export default InternalCompanyApi;
